import { render, staticRenderFns } from "./bgs-editor.vue?vue&type=template&id=11da1e86"
import script from "./bgs-editor.vue?vue&type=script&lang=js"
export * from "./bgs-editor.vue?vue&type=script&lang=js"
import style0 from "./bgs-editor.vue?vue&type=style&index=0&id=11da1e86&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports